import { render, staticRenderFns } from "./press-row.vue?vue&type=template&id=1f417cc7&"
import script from "./press-row.vue?vue&type=script&lang=js&"
export * from "./press-row.vue?vue&type=script&lang=js&"
import style0 from "./press-row.vue?vue&type=style&index=0&id=1f417cc7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports